/**
 * Pure presentation helpers for ProjectListPage. Kept out of the component
 * so the auth-gated branches are covered by unit tests without a DOM.
 */

export function shouldShowCreateProjectButton(isAdmin: boolean): boolean {
  return isAdmin === true;
}

export function emptyProjectsMessage(isAdmin: boolean): string {
  return isAdmin
    ? 'プロジェクトがありません。右上から新規作成してください。'
    : '招待されたプロジェクトがまだありません。プロジェクト管理者にご連絡ください。';
}
